import { DomElement, DomElementTemplate, ViewStream } from "spyne";
import { PageDocsCardCalloutTraits } from "traits/page-docs-card-callout-traits";
import { UtilTraits } from "traits/util-traits";

export class PageDocsItemBlockCardCallout extends ViewStream {
  constructor(props = {}) {
    const idStr = String(props.data.type).toLowerCase();
    props.id = `card-callout-${idStr}`;
    props.class = `card-callout card-callout-${idStr}`;
    props.traits = [PageDocsCardCalloutTraits];
    //console.log("CARD CALLOUT DATA", props.data);

    props.template = `    
    <div class="card-callout-item callout-title"><h3 class="card-callout-title">{{title}} <span>{{description}}</span></h3></div>

    <div class='callout-chart'>
    
    <ul class='core-concept-list'>

    </uL
    
    
</div>

`;

    props.templateOld = `     <div class="card-callout-eyebrow"><p>{{eyebrow}}</p></div><div class="card-callout-row  level-0">
    <div class="card-callout-item callout-title"><h3 class="card-callout-title">{{title}}</h3></div>
    <div class="card-callout-item callout-description"><p class="callout-description">{{description}}</p></div>
  </div>
    <div class='callout-chart'>
    
    <ul class='core-concept-list'>

    </uL
    
    
</div>

`;

    super(props);
  }

  addActionListeners() {
    // return nested array(s)
    return [];
  }

  broadcastEvents() {
    // return nested array(s)
    return [["a", "click"]];
  }

  scrollIntoView() {
    // Select the element
    const introCalloutElement = this.props.el;

    // Check if the element exists
    if (introCalloutElement) {
      // Scroll the element into view
      introCalloutElement.scrollIntoView({
        block: "start", // Align the element to the start of the viewport
      });

      // Add an offset of 400px above
      setTimeout(() => {
        const offset = 400;
        window.scrollBy({
          top: -offset, // Adjust scrolling upwards
        });
      }, 300); // Timeout to allow initial scrollIntoView to complete
    } else {
      console.error(
        'Element with class ".docs-item-block-introCallout" not found.',
      );
    }
  }

  onRendered() {
    this.cardCallout$Init();

    this.cardCallout$RenderCoreConceptChart();

    /*      if (this.props.data.type==='ViewStream'){
          this.cardCallout$RenderCoreConceptChart();
      } else {
        const htmlStr = this.cardCallout$GenerateTable();
        //console.log('callout data is ', {htmlStr});
        this.props.el$('.callout-chart').el.innerHTML = htmlStr;
      }*/

    if (this.props.data.type === "Channel") {
      // window.setTimeout(this.scrollIntoView.bind(this), 500);
    }
  }
}
